<template>
  <CSidebar
    fixed
    class="preika-sidebar"
    :minimize="minimize"
    :show="show"
    @update:show="value => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand>
      <div
        class="preika-sidebar-brand"
        role="button"
        tabindex="0"
        aria-label="ダッシュボードへ移動"
        @click="redirectToPage"
        @keyup.enter="redirectToPage"
      >
        <img
          src="/img/avatars/preika.png"
          alt="PREIKA"
          class="preika-sidebar-brand__logo"
        >
      </div>
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="navItems"/>

    <div class="preika-sidebar-meta">
      <span class="preika-sidebar-meta__dot"></span>
      <span class="preika-sidebar-meta__copy">PREIKA Secure Workspace</span>
    </div>
  </CSidebar>
</template>

<script>
import axios from 'axios'
import nav from './_nav'

export default {
  name: 'TheSidebar',
  nav,

  data () {
    return {
      navItems: nav
    }
  },

  computed: {
    show () {
      return this.$store.state.sidebarShow
    },

    minimize () {
      return this.$store.state.sidebarMinimize
    },

    sidebarBadgeRefreshTick () {
      return this.$store.state.sidebarBadgeRefreshTick
    }
  },

  mounted () {
    this.fetchSidebarBadges()
  },

  watch: {
    sidebarBadgeRefreshTick () {
      this.fetchSidebarBadges()
    }
  },

  methods: {
    redirectToPage () {
      if (this.$route.path !== '/dashboard') {
        this.$router.push('/dashboard')
      }
    },

    fetchSidebarBadges () {
      this.fetchSubmissionListCount()
      this.fetchApprovalPendingCount()
    },

    fetchSubmissionListCount () {
      const origin = process.env.VUE_APP_API_ORIGIN

      return axios
        .get(origin + '/submission/list')
        .then(response => {
          const count = Array.isArray(response.data) ? response.data.length : 0
          this.setNavBadgeByTo('/submission_approval/report_list', count)
        })
        .catch(error => {
          axios
            .get(`${origin}/error/frontError/${error}`)
            .then(() => {})
            .catch(() => {})

          this.setNavBadgeByTo('/submission_approval/report_list', 0)
        })
    },

    setNavBadgeByTo (to, count) {
      const item = this.findNavItemByTo(this.navItems, to)
      if (!item) return

      const numericCount = Number(count)
      if (!Number.isFinite(numericCount) || numericCount <= 0) {
        this.$set(item, 'badge', null)
        return
      }

      this.$set(item, 'badge', {
        color: 'danger',
        text: numericCount > 99 ? '99+' : String(numericCount)
      })
    },

    findNavItemByTo (items, to) {
      if (!Array.isArray(items)) return null

      for (let index = 0; index < items.length; index += 1) {
        const item = items[index]
        if (item && item.to === to) return item

        if (item && Array.isArray(item._children)) {
          const found = this.findNavItemByTo(item._children, to)
          if (found) return found
        }
      }

      return null
    },

    fetchApprovalPendingCount () {
      const origin = process.env.VUE_APP_API_ORIGIN

      return axios
        .get(origin + '/document/approval/list')
        .then(response => {
          const count = Array.isArray(response.data) ? response.data.length : 0
          this.setNavBadgeByTo('/submission_approval/submission_management', count)
        })
        .catch(error => {
          axios
            .get(`${origin}/error/frontError/${error}`)
            .then(() => {})
            .catch(() => {})

          this.setNavBadgeByTo('/submission_approval/submission_management', 0)
        })
    }
  }
}
</script>
